import { render, staticRenderFns } from "./x-menu.vue?vue&type=template&id=1acf7d9e&scoped=true&"
import script from "./x-menu.vue?vue&type=script&lang=js&"
export * from "./x-menu.vue?vue&type=script&lang=js&"
import style0 from "./x-menu.vue?vue&type=style&index=0&id=1acf7d9e&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acf7d9e",
  null
  
)

export default component.exports